import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "@/components/tam/Sidebar";
import { useSecurityGuard } from "@/components/tam/useSecurityGuard";
import { useAuth } from "@/context/AuthContext";
import { logEvent } from "@/lib/api";
import { useTaskAlerts } from "@/components/tam/useTaskAlerts";
import { TaskBanner } from "@/components/tam/TaskBanner";

export default function Layout() {
  const { user } = useAuth();
  const blurred = useSecurityGuard();
  const loc = useLocation();
  const [open, setOpen] = useState(false);
  const alerts = useTaskAlerts(["manager", "purfleet_manager"].includes(user?.role));

  useEffect(() => {
    logEvent("page_view", loc.pathname);
    setOpen(false);
  }, [loc.pathname]);

  return (
    <div className={`tam-secure min-h-screen flex ${blurred ? "tam-blurred" : ""}`} data-testid="app-layout">
      <Sidebar open={open} onClose={() => setOpen(false)} taskCount={alerts.summary?.open} />
      <div className="flex-1 min-w-0 lg:ml-64">
        <header className="lg:hidden sticky top-0 z-30 bg-[#0B132B] text-white flex items-center justify-between px-4 h-14">
          <button onClick={() => setOpen(true)} className="text-sm font-semibold" data-testid="mobile-menu-btn">Menu</button>
          <span className="font-display font-bold tracking-tight">TAM</span>
          <span className="text-xs text-slate-300">{user?.name}</span>
        </header>
        <TaskBanner task={alerts.banner} onDismiss={alerts.dismiss} />
        <main className="tam-content px-4 sm:px-8 lg:px-10 py-8 max-w-[1500px]">
          <Outlet />
        </main>
      </div>
      {blurred && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center pointer-events-none" data-testid="blur-shield">
          <div className="bg-[#0B132B] text-white px-6 py-4 rounded-md text-sm shadow-xl">Content hidden while TAM is not in focus</div>
        </div>
      )}
    </div>
  );
}
